import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LOGON_INFO, USER_TYPE, COMP_TYPE, MENU_ROLE } from './app.constants';
import { MessageService } from './common/message.service';
import { CommonService } from './app.service';
import { SwUpdate } from '@angular/service-worker';
import { DeviceDetectorService } from 'ngx-device-detector';
import $ from 'jquery';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

    USER_TYPE: any = USER_TYPE;
    COMP_TYPE: any = COMP_TYPE;
    LOGIN_INFO: any = LOGON_INFO;
    MENU_ROLE: any = MENU_ROLE;

    constructor(
        private swUpdate: SwUpdate,
        private router: Router,
        private msgService: MessageService,
        private commonService: CommonService,
        private deviceService: DeviceDetectorService
    ) {
        const device_info = this.deviceService.getDeviceInfo();

        if (device_info.os.toLowerCase() != "windows") {
            let viewport = document.querySelector("meta[name=viewport]");
            let content = 'initial-scale=1.0';

            if (window.innerWidth > 1024) {
                // 大画面
                content = 'initial-scale=0.63';
            } else if (window.innerWidth > 768 && window.innerWidth <= 1024) {
                // iPadMini横画面 & 大画面スマートフォン縦画面
                content = 'initial-scale=0.56';
            } else if (window.innerWidth > 430 && window.innerWidth <= 768) {
                // iPadMini縦画面 & スマートフォン縦画面
                content = 'initial-scale=0.43';
            } else {
                // iPhone14Pro縦画面
                content = 'initial-scale=0.36';
            }

            viewport.setAttribute('content', content);
        }
    }


    ngOnInit() {
        if (this.swUpdate.isEnabled) {
            this.swUpdate.available.subscribe(event => {
                this.msgService.addInfo("新しいバージョンがリリースされました。画面をリフレッシュして新バージョンを読み込みください。");
            });
            this.swUpdate.checkForUpdate();
        } else {
            console.log("swUpdate disabled!!!");
        }

        //tooltip
        $(document).ready(function() {
            $("body").tooltip({ selector: '[data-toggle=tooltip]' });
        });

        //tooltip表示制御（文字列が表示幅より長い場合のみ表示）
        $(document).on('mouseover', 'td, th', function() {
            if (this.offsetWidth < this.scrollWidth) {
                $(this).tooltip('show');
            } else {
                $(this).tooltip('hide');
            }
        });
    }


    moveToHome() {
        let homeURL = "";
        switch (LOGON_INFO.USER_DIV) {
            case USER_TYPE.CLIENT:
                homeURL = "/cargo/client";
                break;
            case USER_TYPE.DRIVER:
                homeURL = "/mobile/main";
                break;
            case USER_TYPE.TRANS_MANAGER:
            case USER_TYPE.TRANS_HAISHAMAN:
                homeURL = "/notice-show";
                break;
        }
        this.router.navigate([homeURL]);
    }


    logout() {
        this.router.navigate(['/login']);
        this.msgService.clearAll();
        sessionStorage.clear();
    }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts